export const calculateAverage=(arr)=>{
    return arr.reduce((acc,item)=>{return acc+=item},0)/arr.length
 }